import React from 'react';
import { Tab as MuiTab } from '@mui/material';
import styled from '@emotion/styled';

interface TabProps {
  label: string;
  tabId: number;
}

export const Tab = React.forwardRef<HTMLDivElement, TabProps>(function Tab({ label, tabId, ...rest }, ref) {
  return (
    <StyledTab
      ref={ref}
      label={label}
      value={tabId}
      id={tabId.toString()}
      aria-controls={`${tabId}-panel`}
      sx={{ textTransform: 'none' }}
      {...rest}
    />
  );
});

const StyledTab = styled(MuiTab)``;
